module.exports = __webpack_public_path__ + "static/img/scan.2ca2147e.gif";